import requestInterface from "./requestInterface";

export default {
  init(opts) {
    const makeRequest = requestInterface.init(opts);

    return {
      accountData(requestPayload) {
        const { url, method,data, isExternal, externalHeader, queryParams, contentType,canCancel,isBhoomiUrl = false } = requestPayload;
        return makeRequest.request(url, method, queryParams, data, contentType, isExternal, externalHeader,canCancel,isBhoomiUrl);
      },
      submitRecommendForm(requestPayload) {
        const { url, method, data, isExternal, externalHeader, queryParams, contentType,isBhoomiUrl} = requestPayload;
        return makeRequest.request(url, method, queryParams, data, contentType, isExternal, externalHeader,false,isBhoomiUrl);
      }
    };
  },
};
